<template>
  <div>
    <!-- Tabs -->
    <div class="row mb-3">
      <div class="col-lg-6">
        <div class="mb-1 nav nav-tabs nav-fill">
          <div :class="[ratesStep === 'movers' ? 'active' : '']"
               class="nav-item nav-link pointer"
               @click="setRatesStep('movers')"
          >
            Movers
          </div>
          <div :class="[ratesStep === 'trucks' ? 'active' : '']"
               class="nav-item nav-link pointer"
               @click="setRatesStep('trucks')"
          >
            Trucks
          </div>
        </div>
      </div>
    </div>
    <!-- Companies select -->
    <div class="row mb-3">
      <div class="col-6">
        <span v-if="!selectedCompany"
              class="text-danger float-right mt-2"
        >
          Please select company</span>
      </div>
      <div class="col-6">
        <div class="select-wrap">
          <label>Company</label>
          <simple-select v-model="selectedCompany"
                         :options="companies"
                         placeholder="Select Company"
                         @input="fetchCalendar"
          />
        </div>
      </div>
    </div>
    <!-- Show movers calendar -->
    <section v-if="ratesStep === 'movers'">
      <div class="row mb-3">
        <div class="col">
          <full-calendar :event-sources="eventSourcesMovers"
                         :config="config"
                         ref="calendarMovers"
          />
        </div>
      </div>
    </section>

    <!-- Show trucks calendar -->
    <section v-if="ratesStep === 'trucks'">
      <div class="row mb-3">
        <div class="col">
          <full-calendar :event-sources="eventSourcesTrucks"
                         :config="config"
                         ref="calendarTrucks"
          />
        </div>
      </div>
    </section>

    <!-- Modal price movers -->
    <modal v-if="showModalPriceMovers"
           @close="showModalPriceMovers = false"
    >
      <div slot="header">
        <h4>Change mover price</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <p class="text-center">{{ newPrice.startDate }} - {{ newPrice.endDate }}</p>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <input type="radio"
                   id="amountMovers"
                   value="$"
                   v-model="newPrice.unit"
            />
            <label for="amountMovers">Amount</label>
            <br />
            <input type="radio"
                   id="percentMovers"
                   value="%"
                   v-model="newPrice.unit"
            />
            <label for="percentMovers">Percent</label>
          </div>
          <div class="col-5">
            <div class="select-wrap">
              <label>Amount</label>
              <input class="form-control"
                     placeholder="Enter amount"
                     v-model="newPrice.value"
                     @keydown="clearError($event)"
              />
            </div>
          </div>
          <div class="col-1 pl-0 pt-3">
            <span v-if="newPrice.unit === '$'">$ </span>
            <span v-if="newPrice.unit === '%'">% </span>
          </div>
        </div>
        <error-field :errors="errors" field="value" />
      </div>
      <div slot="footer">
        <div class="row mt-3">
          <div class="col-12">
            <button class="btn btn-primary pull-right"
                    @click="saveNewPriceMovers"
            >
              Proceed
            </button>
            <button class="btn btn-secondary"
                    @click="deletePriceMovers"
            >
              Delete modifier
            </button>
          </div>
        </div>
      </div>
    </modal>

    <!-- Modal price trucks -->
    <modal v-if="showModalPriceTrucks"
           @close="showModalPriceTrucks = false"
    >
      <div slot="header">
        <h1>Change trucks price</h1>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <p class="text-center">{{ newPrice.startDate }} - {{ newPrice.endDate }}</p>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6">
            <input type="radio"
                   id="amountTruck"
                   value="$"
                   v-model="newPrice.unit"
            />
            <label for="amountTruck">Amount</label>
            <br />
            <input type="radio"
                   id="percentTruck"
                   value="%"
                   v-model="newPrice.unit"
            />
            <label for="percentTruck">Percent</label>
          </div>
          <div class="col-5">
            <div class="select-wrap">
              <label>Amount</label>
              <input class="form-control"
                     v-model="newPrice.value"
                     @keydown="clearError($event)"
              />
            </div>
            <error-field :errors="errors" field="value" />
          </div>
          <div class="col-1 pl-0 pt-3">
            <span v-if="newPrice.unit === '$'">$ </span>
            <span v-if="newPrice.unit === '%'">% </span>
          </div>
        </div>
        <error-field :errors="errors" field="type_id" />
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12">
            <button class="btn btn-primary pull-right"
                    @click="saveNewPriceTrucks"
            >
              Proceed
            </button>
            <button class="btn btn-secondary"
                    @click="deletePriceTrucks"
            >
              Delete modifier
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { FullCalendar } from 'vue-full-calendar';
import moment from 'moment/moment';
import Modal from '../Modal';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  name: 'Rates',
  components: {
    Modal,
    ErrorField,
    FullCalendar,
  },
  data() {
    return {
      ratesStep: 'movers',
      selectedCompany: null,
      showModalPriceMovers: false,
      showModalPriceTrucks: false,
      newPrice: {
        date: [],
        value: '',
        unit: '$',
        type_id: 1,
        startDate: '',
        endDate: '',
      },
      eventSourcesMovers: this.fetchEventsMovers(),
      eventSourcesTrucks: this.fetchEventsTrucks(),
      config: {
        weekends: true,
        forceEventDuration: false,
        displayEventEnd: true, // adds end time to month view
        firstDay: 1,
        editable: false,
        slotEventOverlap: false,
        selectable: true,
        defaultView: 'month',
        header: {
          left: 'prev, today',
          right: 'next',
        },
        select: (startDate, endDate) => {
          if (this.$_can('companies.configurations.store')) {
            this.showModalMethod(startDate, endDate);
          }
        },
        eventColor: 'blue',
        eventTextColor: 'white',
      },
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState({
      companies: state => state.companies.companies.data,
    }),
  },
  methods: {
    fetchCalendar() {
      if (this.ratesStep === 'movers') {
        this.$refs.calendarMovers.$emit('refetch-events');
      } else {
        this.$refs.calendarTrucks.$emit('refetch-events');
      }
    },
    fetchEventsMovers() {
      const vm = this;
      return [
        {
          events(start, end, timezone, callback) {
            if (vm.selectedCompany) {
              axios
                .get(
                  `/companies/${vm.selectedCompany}/movers/prices/calendar?date_from=${start.format(
                    'MM/DD/YYYY',
                  )}&date_to=${end.format('MM/DD/YYYY')}`,
                )
                .then(response => {
                  response.data.forEach(el => {
                    const element = el;
                    element.title = `$ ${element.title}\n`;
                    if (el.modifier) {
                      element.title += `${el.unit === '$' ? el.unit : ''} ${
                        el.modifierType === '+' ? el.modifierType : ''
                      }${el.modifier}${el.unit === '%' ? el.unit : ''}`;
                    }
                  });
                  callback(response.data);
                })
                .catch(err => this.errors.record(err.response.data.error));
            }
          },
        },
      ];
    },
    fetchEventsTrucks() {
      const vm = this;
      return [
        {
          events(start, end, timezone, callback) {
            if (vm.selectedCompany) {
              axios
                .get(
                  `/companies/${vm.selectedCompany}/trucks/prices/calendar?date_from=${start.format(
                    'MM/DD/YYYY',
                  )}&date_to=${end.format('MM/DD/YYYY')}`,
                )
                .then(response => {
                  response.data.forEach(el => {
                    const element = el;
                    element.title = `$ ${el.title}\n`;
                    if (element.modifier) {
                      element.title += `${el.unit === '$' ? el.unit : ''} ${
                        el.modifierType === '+' ? el.modifierType : ''
                      }${el.modifier}${el.unit === '%' ? el.unit : ''}`;
                    }
                  });
                  callback(response.data);
                })
                .catch(err => this.errors.record(err.response.data.error));
            }
          },
        },
      ];
    },
    setRatesStep(step) {
      this.ratesStep = step;
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    showModalMethod(startDate, endDate) {
      this.newPrice.startDate = startDate.format('MMM Do');
      this.newPrice.endDate = endDate.format('MMM Do YYYY');
      const dateArray = [];
      let currentDate = moment(startDate);
      const stopDate = moment(endDate);
      while (currentDate < stopDate) {
        dateArray.push(moment(currentDate).format());
        currentDate = moment(currentDate).add(1, 'days');
      }
      this.newPrice.date = dateArray;
      if (this.ratesStep === 'movers') {
        this.showModalPriceMovers = true;
      } else {
        this.showModalPriceTrucks = true;
      }
    },
    saveNewPriceMovers() {
      axios
        .post(`/companies/${this.selectedCompany}/movers/prices/modifiers`, { ...this.newPrice })
        .then(() => {
          this.$refs.calendarMovers.$emit('refetch-events');
          this.showModalPriceMovers = false;
          this.newPrice = {
            date: [],
            value: '',
            unit: '$',
            type_id: 1,
            startDate: '',
            endDate: '',
          };
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    deletePriceMovers() {
      axios
        .delete(`/companies/${this.selectedCompany}/movers/prices/modifiers`, {
          data: { date: this.newPrice.date },
        })
        .then(() => {
          this.$refs.calendarMovers.$emit('refetch-events');
          this.showModalPriceMovers = false;
          this.newPrice = {
            date: [],
            value: '',
            unit: '$',
            type_id: 1,
            startDate: '',
            endDate: '',
          };
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    saveNewPriceTrucks() {
      axios
        .post(`/companies/${this.selectedCompany}/configurations`, { ...this.newPrice })
        .then(() => {
          this.$refs.calendarTrucks.$emit('refetch-events');
          this.showModalPriceTrucks = false;
          this.newPrice = {
            date: [],
            value: '',
            unit: '$',
            type_id: 1,
            startDate: '',
            endDate: '',
          };
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    deletePriceTrucks() {
      axios
        .delete(`/companies/${this.selectedCompany}/configurations`, {
          data: {
            date: this.newPrice.date,
            type_id: 1,
          },
        })
        .then(() => {
          this.$refs.calendarTrucks.$emit('refetch-events');
          this.showModalPriceTrucks = false;
          this.newPrice = {
            date: [],
            value: '',
            unit: '$',
            type_id: 1,
            startDate: '',
            endDate: '',
          };
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/rates/Rates.vue